import { Appointment } from "../types/appointment.definition";
import { Patient, PublicPatient } from "../types/patient.definition";
import { KeywordSearchRequest, PaginationSettingsResponse, SearchRequest } from "../types/search.definition";
import {
  createPatient,
  getPatientAppointments,
  getPatientById,
  getPatientPublic,
  searchPatients,
  searchPatientsPublic,
  searchPatientByPhoneNumberNameOrEmail,
  updatePatient,
} from "../webclients/patient.client";

const patientApi = {
  searchPatientByPhoneNumberNameOrEmail: async (
    query: KeywordSearchRequest
  ) => {
    const response = await searchPatientByPhoneNumberNameOrEmail(query);
    return response.data;
  },
  getPatientById: async (patientId: string) => {
    const response = await getPatientById(patientId);
    return response.data;
  },
  getPatientPublic: async (patientId: string): Promise<PublicPatient> => {
    const response = await getPatientPublic(patientId);
    return response.data;
  },
  searchPatients: async (
    query: SearchRequest
  ): Promise<{ paginationSettings: PaginationSettingsResponse; data: Patient[] }> => {
    const response = await searchPatients(query);
    return response.data;
  },
  searchPatientsPublic: async (
    query: SearchRequest
  ): Promise<{ paginationSettings: PaginationSettingsResponse; data: PublicPatient[] }> => {
    const response = await searchPatientsPublic(query);
    return response.data;
  },
  createPatient: async (facilityId: string | number, patientData: Partial<Patient>) => {
    const response = await createPatient(facilityId, patientData);
    return response.data;
  },
  updatePatient: async (patientId: string, patientData: Partial<Patient>) => {
    const response = await updatePatient(patientId, patientData);
    return response.data;
  },
  getPatientAppointments: async (patientId: string): Promise<Appointment[]> => {
    const response = await getPatientAppointments(patientId);
    return response.data;
  },
};

export default patientApi;
